export const isDefined = (x) => {
    return x !== undefined && x !== null;
};
